import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import "chart.js/auto";
import zoomPlugin from "chartjs-plugin-zoom";
import { Draggable } from "leaflet";

Chart.register(...registerables);
Chart.register(zoomPlugin);

const BarChart = ({
  id,
  labels,
  Bardata,
  type,
  title,
  XAxisLabel,
  YAxisLabel,
  ValueFontSize = 10,
}) => {
  if (!Bardata || !Array.isArray(Bardata) || Bardata.length === 0) {
    return <div className="Nodata">No data available</div>;
  }
  const [minVal, setminVal] = useState(0);
  const [maxVal, setmaxVal] = useState(11);
  const [TitleXAxisLabel, setTitleXAxisLabel] = useState("");

  function getISOWeekNumber(date) {
    const tempDate = new Date(date);
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 4 - (tempDate.getDay() || 7));
    const yearStart = new Date(tempDate.getFullYear(), 0, 1);
    const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);
    return weekNumber;
  }

  function getMinAndMaxWeekNumbers() {
    const today = new Date();
    const maxWeekNumber = getISOWeekNumber(today);

    const minDate = new Date(today);
    minDate.setDate(today.getDate() - 12 * 7);
    const minWeekNumber = getISOWeekNumber(minDate);

    return { maxWeekNumber, minWeekNumber };
  }

  useEffect(() => {
    if (XAxisLabel == "Week" && Bardata.length > 11) {
      const { maxWeekNumber, minWeekNumber } = getMinAndMaxWeekNumbers();
      setmaxVal(maxWeekNumber);
      setminVal(minWeekNumber);
    } else {
      setmaxVal(11);
      setminVal(0);
    }
    if (XAxisLabel == "Week") {
      setTitleXAxisLabel("Weeks");
    } else if (XAxisLabel == "Month") {
      setTitleXAxisLabel("Months");
    } else if (XAxisLabel == "Quarterly") {
      setTitleXAxisLabel("Quarters");
    } else if (XAxisLabel == "Day") {
      setTitleXAxisLabel("Day");
    }
  }, [XAxisLabel, YAxisLabel, labels, Bardata]);

  const colors = [
    "#ebcaae",
    "#f68a78",
    "#f3e573",
    "#ebb556",
    "#79d4c5",
    "#a7e7db",
    "#a7cae7",
    "#50d790",
    "#caee9c",
    "#d1d65d",
    "#fbd9bb",
    "#e3b286",
    "#d17b75",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "Count",
        data: Bardata,
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
        barPercentage:
          Bardata.length == 1
            ? 0.1
            : Bardata.length == 2
            ? 0.2
            : Bardata.length == 3
            ? 0.3
            : Bardata.length == 4
            ? 0.3
            : Bardata.length == 5
            ? 0.4
            : Bardata.length == 6
            ? 0.5
            : Bardata.length == 7
            ? 0.6
            : Bardata.length == 8
            ? 0.6
            : 0.9,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: type,
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            family: "optimare",
            size: 14,
            style: "normal",
            weight: "bold",
            lineHeight: 1.2,
          },
        },
      },

      title: {
        display: true,
        text: title,
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
      },
      datalabels: {
        display: true,
        offset: 4,
        font: {
          size: ValueFontSize,
          family: "optimare",
        },
        formatter: function (value) {
          return value == 0 ? "" : value;
        },
      },
    },
    scales: {
      x: {
        barPercentage: 0.4,
        stacked: true,
        title: {
          display: true,
          text: TitleXAxisLabel,
          color: "#9d7a4d",

          font: {
            family: "optimare",
            weight: "bold",
            lineHeight: 2,
            size: 14,
          },
          padding: { top: 0, left: 0, right: 0, bottom: 10 },
        },
        ticks: {
          font: {
            family: "optimare",
            weight: "bold",
          },
        },
        min: minVal,
        max: maxVal,
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: true,
          offset: true,
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          font: {
            family: "optimare",
            weight: "bold",
          },
        },
        title: {
          display: true,
          text: YAxisLabel,
          color: "#9d7a4d",
          font: {
            family: "optimare",
            weight: "bold",
            lineHeight: 1.2,
            size: 15,
          },
          padding: { top: 0, left: 0, right: 0, bottom: 10 },
        },

        grid: {
          display: true,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: true,
        },
      },
    },
  };
  if (
    !data ||
    data.length == 0 ||
    (data && data.length > 0 && typeof data[0] != "object")
  ) {
    return <KendoLoader />;
  }
  return <Bar data={data} options={options} id={id} width={100} height={50} />;
};

export default BarChart;
